import { APIScope, APIScopePermission, RoleInterface } from "@swivl-mono/types";
import { OldPanel, Panel, Switch, Toggle } from "@swivl-mono/ui";
import { useState } from "react";

import RolesModel from "../../../../Models/Roles/Roles.Model";
import { ActionAndName } from "../Role.Settings.Details.View";

interface PermissionsGroupSectionProps {
  heading: string;
  role: RoleInterface;
  actions: ActionAndName[];
  readOnly: boolean;
}

export function PermissionsGroupSection(props: PermissionsGroupSectionProps) {
  const { heading, role, actions, readOnly } = props;
  const [isOpen, setIsOpen] = useState(false);

  const open = isOpen;
  const mergedActions = RolesModel.mergedActionsForRole(role);

  // calculate if the entire group is on (all actions = ALLOWED)
  const isGroupOn = actions.some((action) => {
    const permission = mergedActions[action.action as APIScope];
    return permission === APIScopePermission.ALLOWED;
  });

  return (
    <OldPanel
      open={open}
      header={heading}
      headerRight={
        <Switch
          readOnly={readOnly}
          on={isGroupOn}
          onSet={(newValue) => {
            const updatedRole = { ...role, actions: { ...role.actions } };

            for (const action of actions) {
              updatedRole.actions[action.action as APIScope] = newValue ? APIScopePermission.ALLOWED : APIScopePermission.FORBIDDEN;
            }

            RolesModel.updateRole(updatedRole);
          }}
        />
      }
      toggleOn={[OldPanel.ToggleOn.HEADER, OldPanel.ToggleOn.CHEVRON]}
      onToggle={() => {
        setIsOpen(!isOpen);
      }}
    >
      {actions.map((action) => {
        const selectedOption = role.actions[action.action] ? (role.actions[action.action] as string) : APIScopePermission.FORBIDDEN;
        return (
          <div key={action.action} className="mb-3 flex items-center justify-between pl-5 text-sm">
            {action.label}
            <Toggle
              readOnly={readOnly}
              options={[
                { value: APIScopePermission.ALLOWED, label: "Allowed" },
                {
                  value: APIScopePermission.FORBIDDEN,
                  label: "Forbidden"
                }
              ]}
              selectedOption={selectedOption}
              onOptionSelected={(option) => {
                // update role
                // remove from role
                let updatedRole = { ...role };

                updatedRole.actions[action.action] = option.value as APIScopePermission;

                RolesModel.updateRole(updatedRole);
              }}
            />
          </div>
        );
      })}
    </OldPanel>
  );
}
